import { handleActions } from "redux-actions";
import { api } from "api";
import moment from "moment";
import Swal from "sweetalert2";
import { ToastStore } from "react-toasts";

const endpoint = "aperturas_cierres_caja";

// ------------------------------------
// Constants
// ------------------------------------

export const DATA = "AC_DATA";
export const SORT = "AC_SORT";
export const PAGE = "AC_PAGE";
export const FECHA_INICIAL = "AC_FECHA_INICIAL";
export const FECHA_FINAL = "AC_FECHA_FINAL";
export const LOADER = "AC_LOADER";
export const USUARIO = "AC_USUARIO";
export const ESTADO_DESCARGA = "AC_ESTADO_DESCARGA";

// ------------------------------------
// Actions
// ------------------------------------

export const leer = (page = 1) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();
    const fecha_inicial = store.apertura_cierre.fecha_inicial;
    const fecha_final = store.apertura_cierre.fecha_final;
    const params = { fecha_final, fecha_inicial, page };
    const usuario = store.apertura_cierre.usuario;
    params.ordering = store.apertura_cierre.ordering;
    if (usuario) params.usuario_id = usuario.id;
    api.get(`${endpoint}/reporte`, params)
        .catch((err) => {
            Swal("ERROR", "Ha ocurrido un error.", "error");
        })
        .then((resp) => {
            if (resp) {
                dispatch(setData(resp));
                dispatch(setPage(page));
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const setUsuario = (value) => (dispatch) => {
    dispatch(_setUsuario(value));
    dispatch(leer());
};

export const setFecha = (key, value) => (dispatch, getStore) => {
    const store = getStore();
    const apertura_cierre = store.apertura_cierre;
    if (key === "Inicial") {
        const fecha_inicial = new Date(value);
        const fecha_final = new Date(apertura_cierre.fecha_final);
        if (fecha_final >= fecha_inicial) dispatch(setFechaInicial(value));
    } else {
        const fecha_inicial = new Date(apertura_cierre.fecha_inicial);
        const fecha_final = new Date(value);
        if (fecha_final >= fecha_inicial) dispatch(setFechaFinal(value));
    }
    dispatch(leer());
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.apertura_cierre.page;
    dispatch(leer(page));
};

export const descargarListado = () => (dispatch, getStore) => {
    const store = getStore();
    const fecha_inicial = store.apertura_cierre.fecha_inicial;
    const fecha_final = store.apertura_cierre.fecha_final;
    let params = { fecha_final, fecha_inicial };
    const usuario = store.apertura_cierre.usuario;
    params.ordering = store.apertura_cierre.ordering;
    if (usuario) params.usuario_id = usuario.id;

    dispatch(setEstadoDescarga(true));
    api.get(`${endpoint}/descargar_excel_reporte`, params)
        .catch((err) => {
            Swal(
                "¡Error al descargar!",
                "Ocurrió un error al descargar el archivo. Por favor intenté más tarde.",
                "error"
            );
            dispatch(setEstadoDescarga(false));
        })
        .then((data) => {
            if (data) {
                Swal(
                    "¡Descarga en proceso!",
                    "La descarga comenzará en un momento. Por favor no recargue la página hasta que se haya descargado el archivo",
                    "info"
                );
                dispatch(setEstadoDescarga(true));
                dispatch(esperarDescarga(data.id));
            }
        });
};

const esperarDescarga = (id) => (dispatch) => {
    let intervalPromise;

    //  VOLVER A HACER LA PETICIÓN PARA VERIFICAR QUE YA TERMINO LA DESCARGA

    function listener() {
        api.get("archivos/estado_descarga", { id })
            .catch((err) => {
                let msg =
                    "Ocurrió un error al descargar el archivo. Por favor intenta más tarde";
                if (err.estado) {
                    msg = err.observaciones;
                }
                dispatch(setEstadoDescarga(false));
                clearInterval(intervalPromise);
                Swal("Error al descargar!", msg, "error");
            })
            .then((resp) => {
                if (resp.estado === 10) {
                    // PROCESANDO
                    dispatch(setEstadoDescarga(true));
                } else if (resp.estado === 20) {
                    // TERMINADO
                    clearInterval(intervalPromise);
                    let nombre = resp.archivo
                        ? resp.archivo.split("/media/archivos/")[1]
                        : "Bajas_salidas_por_producto.xlsx";
                    const context = {
                        name: name,
                        url: resp.archivo,
                    };

                    dispatch(setEstadoDescarga(false));
                    dispatch(descargaArchivo(context));
                }
            });
    }

    listener();
    intervalPromise = setInterval(listener, 1000);
};

const descargaArchivo = (context) => (dispatch) => {
    let elem = document.createElement("a");
    elem.href = context.url;
    elem.download = context.name;
    elem.target = "hiddenIframe";
    elem.click();
    dispatch(setEstadoDescarga(false));
    ToastStore.success("Archivo descargado exitosamente");
};

// ------------------------------------
// PureActions
// ------------------------------------

export const setFechaInicial = (fecha_inicial) => ({
    type: FECHA_INICIAL,
    fecha_inicial,
});

export const setFechaFinal = (fecha_final) => ({
    type: FECHA_FINAL,
    fecha_final,
});

export const setData = (data) => ({
    type: DATA,
    data,
});

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const _setUsuario = (usuario) => ({
    type: USUARIO,
    usuario,
});

export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});

export const setPage = (page) => ({
    type: PAGE,
    page,
});

const setEstadoDescarga = (estado_descarga) => ({
    type: ESTADO_DESCARGA,
    estado_descarga,
});

export const actions = {
    leer,
    setFecha,
    setUsuario,
    sortChange,
    descargarListado,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [FECHA_INICIAL]: (state, { fecha_inicial }) => {
        return {
            ...state,
            fecha_inicial,
        };
    },
    [FECHA_FINAL]: (state, { fecha_final }) => {
        return {
            ...state,
            fecha_final,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [USUARIO]: (state, { usuario }) => {
        return {
            ...state,
            usuario,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ESTADO_DESCARGA]: (state, { estado_descarga }) => {
        return {
            ...state,
            estado_descarga,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    page: 1,
    data_grafica: {},
    usuario: null,
    fecha_inicial: moment().format("YYYY-MM-DD"),
    ordering: "",
    fecha_final: moment().format("YYYY-MM-DD"),
    loader: false,
    estado_descarga: false,
};

export default handleActions(reducers, initialState);
